import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import testIcon from '../../../Assets/Icons/test-icon.svg';
import healthIcon from '../../../Assets/Icons/health-checkup.svg';
import playStore from '../../../Assets/Icons/playstore.png';
import appStore from '../../../Assets/Icons/apple.png';
import testSpecialtyIcon from '../../../Assets/Icons/testing-specialty.svg';
import SearchModal from '../Components/SearchModal';
import { decodeEntities, slugify } from 'Utils/Functions';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useSelector } from 'react-redux';

const Banner = ({ data, heading, content }) => {
  const [openSearchModal, setOpenSearchModal] = useState(false);
  let { city: cityName } = useParams();
  let citySlug = slugify(cityName);
  const navigation = useNavigate();
  cityName = slugify(cityName);
  console.log(citySlug, cityName, 'cityName');

  const handleCloseModal = () => {
    setOpenSearchModal(false);
  };

  const homeVisit = () => {
    navigation(`/${citySlug}/book-a-home-visit`);
  };

  const LabVisit = () => {
    navigation(`/${citySlug}/book-a-lab-visit`);
  };

  const settings = {
    arrows: false,
    dots: true,
    infinite: data?.length > 1, // Only enable infinite loop if there's more than one slide
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };

  return (
    <>
      <section className="home-hero-section">
        <div className="store">
          <Link
            to="https://play.google.com/store/apps/details?id=com.unipath"
            className="play-store"
            target="_blank"
          >
            <img
              alt=""
              src={playStore}
            />
          </Link>
          <Link
            to="https://apps.apple.com/in/app/unipath-blood-test/id6711355606"
            className="app-store"
            target="_blank"
          >
            <img
              alt=""
              src={appStore}
            />
          </Link>
        </div>

        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12">
              <div className="hero-content-wrapper h-100">
                <div className="hero-slider-inner-content">
                  <div className="hero-slider-content-item">
                    <div className="hero-slider">
                      {data?.length > 0 && (
                        <Slider {...settings}>
                          {data.map((item, index) => (
                            <div key={index}>
                              <Link
                                to={
                                  item?.url
                                    ? item?.url
                                    : item?.type === 'Test'
                                    ? `/${cityName}/blood-tests/${btoa(
                                        item?.service_slug
                                      )}`
                                    : item?.type === 'Service'
                                    ? `/${cityName}/health-packages/${item?.service_slug}`
                                    : '#/'
                                }
                                target={item?.url ? '_blank' : '_self'}
                              >
                                <img
                                  src={item.banner_image}
                                  alt={item.banner_title}
                                />
                              </Link>
                            </div>
                          ))}
                        </Slider>
                      )}
                    </div>

                    <div className="hero-slider-content">
                      <div className="hero-slider-heading-component">
                        <h1>
                          {heading
                            ? `${heading} ${cityName ? 'in' : ''}  ${
                                cityName.charAt(0).toUpperCase() +
                                cityName.slice(1)
                              }`
                            : ''}
                        </h1>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: content ? content : ''
                          }}
                        ></p>
                      </div>

                      <div className="hero-slider-btn-booking">
                        <div
                          className="home-visit"
                          onClick={homeVisit}
                        >
                          Book Home Visit
                        </div>
                        <div
                          className="home-visit lab-visit-color"
                          onClick={LabVisit}
                        >
                          Book Lab Visit
                        </div>
                      </div>

                      <input
                        onClick={() => setOpenSearchModal(true)}
                        placeholder="Search for packages & blood tests"
                        className=""
                        type={'text'}
                      />
                      <div className="slider-content-items">
                        <Link
                          className="slider-content-item"
                          to={cityName ? `/${cityName}/blood-tests` : '/blood-tests'}
                        >
                          <div className="item-icon">
                            <img
                              alt=""
                              src={testIcon}
                            />
                          </div>
                          <h5>Book A Blood Tests</h5>
                          {/* <div className="price-tag">
                          Up to <span>75% off</span>
                        </div> */}
                        </Link>

                        <Link
                          className="slider-content-item"
                          to={
                            cityName
                              ? `/${cityName}/health-packages`
                              : '/health-packages'
                          }
                        >
                          <div className="item-icon">
                            <img
                              alt=""
                              src={healthIcon}
                            />
                          </div>
                          <h5>Health Package</h5>
                          <div className="price-tag">
                            Up to <span>75% off</span>
                          </div>
                        </Link>

                        <Link
                          className="slider-content-item"
                          to={`/testing-specialty`}
                        >
                          <div className="item-icon">
                            <img
                              alt=""
                              src={testSpecialtyIcon}
                            />
                          </div>
                          <h5>Testing Specialty</h5>
                          {/* <div className="price-tag">
                          Up to <span>75% off</span>
                        </div> */}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {openSearchModal && (
        <SearchModal
          show={openSearchModal}
          handleCloseModal={handleCloseModal}
        />
      )}
    </>
  );
};

export default Banner;
